import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

/*
USAGE:
<div class="o-form-group__item" data-module="FileLabel">
    <div class="o-filelabel__wrap" data-filelabel="wrap">
        <label class="o-label sr-only" for="file-id" data-filelabel="label">Joindre un fichier</label>
        <div class="o-filelabel">
            <?php svg('attachment'); ?>
            <input class="o-filelabel__input" id="file-id" data-filelabel="input" type="file">
            <span class="o-filelabel__text" data-filelabel="text">Glissez et déposez votre fichier</span>
        </div>
    </div>
</div>
 */
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                input: 'inputChange'
            }
        }
        this.values = {
            default: false
        }
    }

    setAttributes(el, attrs){
        for(var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    init() {
        
        let moduleEl = this.el;
        let moduleId = moduleEl.getAttribute('data-mid');

        let fileLabelInput = moduleEl.querySelectorAll('[data-filelabel="input"]');
        let fileLabel = moduleEl.querySelectorAll('[data-filelabel="label"]');

        if(fileLabelInput.length != fileLabel.length){
            console.error('FileLabel : Number of inputs and labels does not match');
        }

        let i = 1;
        fileLabelInput.forEach(input => {
            this.setAttributes(input,{
                'id': moduleId+'-fileupload-'+i,
                'name': moduleId+'-fileupload-'+i,
                'tabindex': '0'
            })
            i++;
        });
        i = 1;
        fileLabel.forEach(label => {
            this.setAttributes(label,{
                'for': moduleId+'-fileupload-'+i
            })
            i++;
        });
    }

    inputChange(e) {
        let moduleEl = e.target;
        let fileLabel = moduleEl.closest('[data-filelabel="wrap"]').querySelector('[data-filelabel="text"]');
        moduleEl.closest('[data-filelabel="wrap"]').classList.add('has-file');
        // Save default text value
        if(this.values.default == false){
            this.values.default = fileLabel.innerHTML;
        }
        var fullPath = moduleEl.value;
        var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
        var filename = fullPath.substring(startIndex);
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
        } else {
            filename = this.values.default;
        }
        // Set new name
        fileLabel.innerHTML = filename;
    }
}
